// extracted by mini-css-extract-plugin
module.exports = {"create-learner-form":"CreateLearnerForm_create-learner-form__1gDlm","footer":"CreateLearnerForm_footer__1--ev","banner":"CreateLearnerForm_banner__1xM7b"};